<div class="modal-body clear text-center" ngbAutofocus>
  <button type="button" class="fs-close-btn right border-0 bg-transparent p-0" ngbAutofocus (click)="activeModal.dismiss()" data-cy="close-sphere-subscribe-button" aria-label="close">
    <fa-icon icon="times-circle" class="circle-icon-btn" aria-hidden="true"></fa-icon>
  </button>
  <img [src]="contentService.logos[appService.app][appService.activeTheme].dawBoxScreen" style="width: 200px; margin: auto" [alt]="'studioone_grace_period.image_alt' | translate" />
  @if (!status) {
    <div>
      <h3 class="brandfont-black m-t-20">{{ "studioone_grace_period.eligible_redeem" | translate }}</h3>
      {{ "studioone_grace_period.description" | translate }}
      <br />
      <br />
      <button class="btn btn-primary" (click)="redeem()">{{ "studioone_grace_period.redeem_button" | translate }}</button>
    </div>
  }
  @if (status == "redeeming") {
    <myp-inline-loader [loading]="status == 'redeeming'" height="200px" spinnerName="sharePageLoader"></myp-inline-loader>
  }
  @if (status == "success") {
    <div>
      <h3 class="brandfont-black m-t-20">{{ "studioone_grace_period.success" | translate }}</h3>
      <p>{{ "studioone_grace_period.success_message" | translate }}</p>
      <button class="btn btn-primary" (click)="view()">{{ "studioone_grace_period.view_button" | translate }}</button>
    </div>
  }
</div>
